import React from "react";
import values from "lodash/values";
import pick from "lodash/pickBy";
import { Link } from "react-router";
import { RaisedButton } from "material-ui";
import { Table, Sort } from "reactable";

import connectToStores from "alt-utils/lib/connectToStores";
import CouponActions from "../actions/CouponActions";
import CouponStore from "../stores/CouponStore";
import UserStore from "../stores/UserStore";

import WorkingIndicator from "./partials/working-indicator.jsx";

class Coupons extends React.Component {
  constructor(props) {
    super(props);
    this._makeRowForCoupon = this._makeRowForCoupon.bind(this);
  }

  static getStores() {
    return [CouponStore, UserStore];
  }

  static getPropsFromStores() {
    return CouponStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {};
  }

  _makeRowForCoupon(coupon) {
    return {
      Name: coupon.name,
      Code: coupon.multicode ? "(multiple codes)" : coupon.code,
      Active: coupon.active ? "Active" : "Inactive",
      Uses: coupon.uses,
      Actions: (
        <div>
          <Link
            to={{
              pathname: `/event_buckets/${this.props.params.eventBucketId}/coupons/${coupon.id}`,
              state: { fromListing: true }
            }}
          >
            {UserStore.hasPermission("edit_coupon") ? "View" : "View Uses"}
          </Link>
          &nbsp;
          <Link
            to={{
              pathname: `/event_buckets/${this.props.params.eventBucketId}/coupons/${coupon.id}/edit`,
              state: { fromListing: true }
            }}
          >
            {UserStore.hasPermission("edit_coupon") ? "Edit" : "View Details"}
          </Link>
        </div>
      )
    };
  }

  componentWillMount() {
    CouponActions.fetchAllForBucket(this.props.params.eventBucketId);
  }

  render() {
    let styles = this.getStyles(),
      bucket = this.props.params.eventBucketId,
      coupons = values(
        pick(this.props.coupons, c => c.event_bucket === bucket)
      ),
      rows = coupons.map(this._makeRowForCoupon);

    if (coupons.length === 0 && CouponStore.getState().isFetching) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <h1 className="page-title">Discounts</h1>
        <Table
          className="bordered striped responsive-table"
          data={rows}
          sortable={[
            { column: "Name", sortFunction: Sort.CaseInsensitive },
            "Code",
            "Active",
            "Uses"
          ]}
          defaultSort={{ column: "Name", direction: "asc" }}
          columns={["Name", "Code", "Active", "Uses", "Actions"]}
          filterable={["Name", "Code"]}
          filterPlaceholder="Type to filter..."
        />
        {rows.length === 0 ? (
          <div className="empty-table-message">
            No discounts yet.{" "}
            <Link to={`/event_buckets/${bucket}/coupons/new`}>
              Create a new discount.
            </Link>
          </div>
        ) : null}
        {UserStore.hasPermission("edit_coupon") ? (
          <div style={{ marginTop: 20 }}>
            <RaisedButton
              label="Create new discount"
              primary={true}
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${this.props.params.eventBucketId}/coupons/new`
                )
              }
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(Coupons);



// WEBPACK FOOTER //
// ./src/app/components/coupons.jsx